<template>
  <div id="banner">
    <div class="block">
      <el-carousel trigger="click" height="653px">
        <el-carousel-item v-for="(img, index) in imgList" :key="index" >
          <img class="banner_img" v-lazy="img" @click="handlerRedirect(index)" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import { getConstByKey } from '@/services/const-service';
export default {
  name: 'Banner',
  data() {
    return {
      imgList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      try {
        let { data } = await getConstByKey('banner');
        if (data.returnCode === '01') {
          if (data.const) {
            this.imgList = JSON.parse(JSON.parse(data.const.value).bannerList);
          }
        } else {
          this.$message.error('获取banner列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    handlerRedirect(index) {
      window.open(`/api/docs?BANNER${index + 1}`);
    }
  }
};
</script>
<style  lang="less">
#banner {
  height: 653px;
  width: 1366px;
  .el-carousel {
    overflow: hidden;
    cursor: pointer;
  }
}
</style>
